import React, { useEffect, useMemo } from 'react';
import { FuelGridItem } from '@frete.com/fuel-react';
import { useSearchParams } from 'react-router-dom';
import { FormSteps, FormWrapper, Header, PageWrapperSkeleton } from '@/components';
import { Container, Wrapper, Session } from './styled';
import { useAuth, useFeatureToggle } from '@/hooks';
import { useAppContext } from '@/context';
import {
  useAutoLoadTruckerProfile,
  useErrorViewer,
  useLoadTruckTypes,
  useSearchByUuid,
} from '@/components/FormWrapper/hooks';

export const Page: React.FC = () => {
  const { state, dispatch } = useAppContext();
  const { canAccess } = useFeatureToggle();
  const auth = useAuth();
  const errorViewer = useErrorViewer();
  const searchByUuid = useSearchByUuid();
  const loadTruckTypes = useLoadTruckTypes();
  const autoLoadTruckerProfile = useAutoLoadTruckerProfile();
  const [searchParams] = useSearchParams();

  const isLoading = useMemo(
    () =>
      state.risk.isLoading ||
      state.truckTypes.isLoading ||
      state.riskErrorViewer.isLoading ||
      state.truckerProfile.isAutoLoading ||
      state.featureToggle.isLoading,
    [
      state.risk.isLoading,
      state.truckTypes.isLoading,
      state.riskErrorViewer.isLoading,
      state.truckerProfile.isAutoLoading,
      state.featureToggle.isLoading,
    ],
  );

  const loadData = () => {
    errorViewer.handle();
    searchByUuid.handle();
    loadTruckTypes.handle();
    autoLoadTruckerProfile.handle();
  };

  useEffect(() => {
    if (state.featureToggle.isLoading) return;

    const isBeginnerPlan =
      auth.user.company.combo.name === 'Iniciante' || auth.user.company.combo.name === 'Iniciante Antigo';
    if ((isBeginnerPlan && canAccess) || !isBeginnerPlan) loadData();
  }, [canAccess, searchParams, state.featureToggle.isLoading]);

  useEffect(() => {
    dispatch({ action: 'form_id_create' });

    return () => {
      dispatch({ action: 'risk_form_reset' });
    };
  }, []);

  if (isLoading) return <PageWrapperSkeleton />;

  return (
    <Wrapper id="page-wrapper">
      <Session>
        <Container spacingTop={40}>
          <FuelGridItem>
            <Header />
          </FuelGridItem>
          <FuelGridItem>
            <FormSteps />
          </FuelGridItem>
          <FuelGridItem>
            <FormWrapper />
          </FuelGridItem>
        </Container>
      </Session>
    </Wrapper>
  );
};
